// Mock data for Tuxedo Express

export const services = [
  {
    id: 1,
    title: "Dry Cleaning",
    description: "Precision cleaning for staff uniforms and guest wear using advanced technology for professional results.",
    icon: "Shirt"
  },
  {
    id: 2,
    title: "Commercial Laundry",
    description: "Bedding and F&B linens - professional washing, pressing and packing for commercial clients. Delivered in roll cages or hamper bags.",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Express Service",
    description: "Premium quality cleaning in just 4 hours, available every day of the week. Perfect for urgent requirements.",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Hotel & Corporate",
    description: "Bulk processing for restaurants, hotels, and clubs with flexible pickup/delivery scheduling.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Alterations & Repairs",
    description: "Professional tailoring and garment repairs to keep your clothes fitting perfectly with tailored fits that last.",
    icon: "Scissors"
  },
  {
    id: 6,
    title: "F&B Linen & Chef Wear Uniform Rental",
    description: "Napkin and tablecloth rental service. Professional chef jackets, trousers and aprons available for rental. Clean uniforms delivered to your kitchen.",
    icon: "ChefHat"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic Care",
    price: "£25",
    period: "per service",
    features: [
      "Standard dry cleaning",
      "48-hour turnaround",
      "Quality inspection",
      "Eco-friendly solutions",
      "Free hangers"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Premium Service",
    price: "£45",
    period: "per service",
    features: [
      "Express 24-hour service",
      "Premium fabric care",
      "Stain removal treatment",
      "Hand finishing",
      "Delivery available",
      "Priority service"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Corporate Package",
    price: "Custom",
    period: "contact us",
    features: [
      "Bulk order discounts",
      "Dedicated account manager",
      "Flexible pickup/delivery",
      "Monthly invoicing",
      "7-day service",
      "Custom requirements"
    ],
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "The Dorchester Hotel",
    role: "5-Star Luxury Hotel",
    content: "Tuxedo Express has been our trusted partner for over 15 years. Their attention to detail and reliability is unmatched in London.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    role: "Wedding Client",
    content: "They cleaned my wedding dress beautifully and preserved it perfectly. The care and expertise they showed was exceptional.",
    rating: 5
  },
  {
    id: 3,
    name: "Mayfair Members Club",
    role: "Private Club",
    content: "Impeccable service for all our table linens and staff uniforms. Express service is truly express - never a delay.",
    rating: 5
  },
  {
    id: 4,
    name: "James Anderson",
    role: "Corporate Executive",
    content: "As someone who wears suits daily, I trust only Tuxedo Express. My clothes always come back looking brand new.",
    rating: 5
  }
];

export const prestigiousClients = [
  { id: 1, name: "Bvlgari Hotel", displayName: "Bvlgari Hotel", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/zmkekx9x_download%20%286%29.png" },
  { id: 2, name: "The Ritz", displayName: "The Ritz London", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/mom65gox_download.png" },
  { id: 3, name: "The Landmark", displayName: "The Landmark London", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/q2dk5b80_download%20%281%29.png" },
  { id: 4, name: "Chiltern Firehouse", displayName: "Chiltern Firehouse", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/8wc871vv_download%20%282%29.png" },
  { id: 5, name: "Kensington Roof Gardens", displayName: "Kensington Roof Gardens", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/j8hq0k9q_download%20%283%29.png" },
  { id: 6, name: "The 22", displayName: "The Twenty Two", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/ay3ilfq2_download%20%284%29.png" },
  { id: 7, name: "Royal Automobile Club", displayName: "Royal Automobile Club", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/ubthfkao_Royal_Automobile_Club_Logo%20%281%29.jpg" },
  { id: 8, name: "Flemings Mayfair", displayName: "Flemings Mayfair", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/nkw8k80k_download%20%285%29.png" },
  { id: 9, name: "Hyatt", displayName: "Great Scotland Yard Hotel", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/lk8exmna_images.png" },
  { id: 10, name: "Oxford & Cambridge Club", displayName: "Oxford & Cambridge Club", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/wtyxqtrl_images.jpeg" },
  { id: 12, name: "Royal Society of Medicine", displayName: "Royal Society of Medicine", logo: "https://customer-assets.emergentagent.com/job_tux-plus/artifacts/r0fnvzwq_download.jpeg" }
];

export const locationInfo = {
  address: "64-68 Stewarts Road, London, SW8 4DE, United Kingdom",
  phone: "0207 622 4592",
  email: "laundry@tuxedoexpress.com",
  hours: {
    weekdays: "Monday - Sunday: 9:00 AM - 8:00 PM",
    saturday: "",
    sunday: ""
  },
  coordinates: {
    lat: 51.4764,
    lng: -0.1219
  }
};

export const whyChooseUs = [
  {
    id: 1,
    title: "40+ Years Experience",
    description: "Family-owned business in London since 1982",
    icon: "Award"
  },
  {
    id: 2,
    title: "Expert Handling",
    description: "Specialized in luxury fabrics, uniforms and delicates",
    icon: "Star"
  },
  {
    id: 3,
    title: "Advanced Technology",
    description: "Latest machinery and RFID technology to ensure efficiency and consistent high quality results",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Open Daily",
    description: "7 day service with 4 hour express cleaning available",
    icon: "Clock"
  }
];
